<<template>
  <div class="fileinput text-center">
    <div
            class="fileinput-new thumbnail"
            :class="{ 'img-circle': type === 'avatar' }"
    >
      <img :src="image" onerror="this.onerror=null;this.src='/api/user/release/noImg';" class="imgAdd" alt="preview" />
    </div>

  </div>
</template>

<script>
  export default {
    name: 'image-upload',
    props: {
      type: {
        type: String,
        default: '',
        description: 'Image upload type (""|avatar)'
      },
      src: {
        type: String,
        default: '',
        description: 'Initial image to display'
      },
      selectText: {
        type: String,
        default: 'Выберите обложку'
      },
      changeText: {
        type: String,
        default: 'Изменить'
      },
      removeText: {
        type: String,
        default: 'Удалить'
      }
    },
    data() {
      let avatarPlaceholder = 'img/placeholder.jpg';
      let imgPlaceholder = 'img/image_placeholder.jpg';
      return {
        placeholder: this.type === 'avatar' ? avatarPlaceholder : imgPlaceholder,
        imagePreview: null
      };
    },
    computed: {
      fileExists() {
        return this.imagePreview !== null;
      },
      image() {
        return this.imagePreview || this.src || this.placeholder;
      }
    },
    methods: {
      handlePreview(event) {
        let file = event.target.files[0];
        this.imagePreview = URL.createObjectURL(file);
        this.$emit('change', file);
      },
      removeFile() {
        this.imagePreview = null;
        this.$emit('change', null);
      }
    },
    async mounted(){

    }
  };
</script>
<style>
  .imgAdd{
    weight: 250px !important;
    height: 188px !important;
  }
</style>
